<template>
  <modal
    name="questions-finish-tour-modal"
    :adaptive="true"
    :classes="['questions-finish-tour-modal']"
    :click-to-close="false"
    :height="'auto'"
    :scrollable="true"
  >
    <div class="emoji">
      🎉
    </div>
    <h2 class="title">
      See how easy studying can be?
    </h2>
    <div class="text">
      You’re working smarter, not harder, by learning from explanations and realizing your confidence level. Keep practicing – pick a category and continue your streak.
    </div>
    <button
      class="finish-button"
      @click="goHome()"
    >
      Go Home
    </button>
  </modal>
</template>

<script>
export default {
  methods: {
    goHome() {
      this.$modal.hide('questions-finish-tour-modal');
      this.$router.push({name: 'home'});
      this.$store.commit('navigationItems/resetDynamicNavigationItems');
      setTimeout(() => { this.$store.dispatch('ui/toggleUpsellModal', { show: true, source: { type: 'Finished Tour' } }); }, 3500);
    },
  },
};
</script>

<style lang='scss'>
  .questions-finish-tour-modal {
    background-color: #001c74;
    border-radius: rem-calc(6);
    padding: rem-calc(32);
    position: relative;
    text-align: center;

    @include breakpoint(small) {
      max-width: 98%;
      margin-left: 1%;
      padding: rem-calc(16) rem-calc(16);
    }

    .emoji {
      font-size: rem-calc(40);
      margin-bottom: rem-calc(16);
    }

    .title {
      font-size: rem-calc(32);
      line-height: 1.35;
      margin: 0 auto rem-calc(24) auto;
      max-width: rem-calc(320);
      color: #ffffff;
    }

    .text {
      font-size: rem-calc(16);
      color: #ffffff;
      line-height: 1.25;
      max-width: rem-calc(460);
      margin: 0 auto rem-calc(24);
      &:first-of-type {
        margin-bottom: 0;
      }

      @include breakpoint(small) {
        margin-bottom: rem-calc(40);
      }
    }

    .finish-button {
      background-color: #00d8f8;
      border-radius: rem-calc(24);
      color: #ffffff;
      width: rem-calc(165);
      font-size: rem-calc(20);
      font-weight: $semi-bold;
      margin: rem-calc(44) auto rem-calc(16);
      padding: rem-calc(15) rem-calc(24);
      display: block;

      @include breakpoint(small) {
        margin-top: rem-calc(40);
      }
    }

    .close {
      right: rem-calc(6);
      position: absolute;
      top: rem-calc(6);
      background: transparent;
      border: none;
      padding: 0;
      opacity: 0.4;

      @include breakpoint(small) {
        right: rem-calc(4);
      }

      img {
        height: rem-calc(16);
        width: rem-calc(16);

        @include breakpoint(small) {
          height: rem-calc(20);
          width: rem-calc(20);
        }
      }
    }
  }
</style>
